import script from "./AreaCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./AreaCard.vue?vue&type=script&lang=ts&setup=true"

import "./AreaCard.vue?vue&type=style&index=0&id=7f482f69&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f482f69"]])

export default __exports__